import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import './step_heading.css';

var StepHeading = function (_Component) {
	_inherits(StepHeading, _Component);

	function StepHeading() {
		_classCallCheck(this, StepHeading);

		return _possibleConstructorReturn(this, (StepHeading.__proto__ || Object.getPrototypeOf(StepHeading)).call(this));
	}

	_createClass(StepHeading, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    row_title = _props.row_title,
			    index = _props.index;

			var uniq_class = 'step_heading_' + index;
			return React.createElement(
				'button',
				{ className: 'step_heading ' + uniq_class },
				React.createElement(
					'span',
					{ className: 'step_heading_title' },
					row_title
				)
			);
		}
	}]);

	return StepHeading;
}(Component);

export default StepHeading;